import React, { useCallback, useEffect, useState } from 'react'
import Table from './components/table'
import { ct } from './constants/index'
import Tabs from './components/tabs'
import { makeRequest } from '../../js/utils/makeRequest'
import './style.css'
import { getActiveTab } from './utils'
import { CalculatorContext } from './context/index'
import Placeholder from './components/loader'

const App = ({ url, initialTabs, claritySort = ['I1', 'I2', 'I3', 'IF', 'SI1', 'SI2', 'SI3', 'VS1', 'VS2', 'VVS1', 'VVS2'] }) => {
  const [allTables, setAllTables] = useState([])
  const [tabs, setTabs] = useState(initialTabs)
  const [price, setPrice] = useState('- || -')
  const [permissibleValues, setPermissibleValues] = useState({})
  const [activeCell, setActiveCell] = useState('')
  const [calculatorIsShow, setCalculatorIsShow] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [activeRowCol, setActiveRowCol] = useState({})

  const setActiveTab = (index) => {
    setTabs((prevState) => prevState.map((tab, i) => {
      tab.isActive = i === index
      return tab
    }
    ))
  }

  useEffect(() => {
    setActiveCell('')
    setPrice('- || -')
    setPermissibleValues({})
    setActiveRowCol({})
    toggleCalculator(false)

    setAllTables((prevState) => prevState.map((table) => {
      return table.map((cell) => {
        cell.isActive = cell.is_round === getActiveTab(tabs).isRound
        return cell
      })
    }))
  }, [tabs])

  useEffect(() => {
    makeRequest({ url })
      .then(({ success, data, errors }) => {
        if (success) {
          return data
        } else {
          return Promise.reject(errors)
        }
      })
      .then((data) => {
        data = data.filter((item) => item.min >= 0.3)
        return data
      })
      .then((data) => {
        return [...ct].map((ctItem) => {
          return data.filter((item) => item.min >= ctItem.min && item.max <= ctItem.max)
        })
      })
      .then((tables) => {
        setAllTables([...tables].map((table) => {
          return table.map((cell) => {
            cell.isActive = cell.is_round === getActiveTab(tabs).isRound
            return cell
          })
        }))
      })
      .catch((e) => {
        $.fancybox.open({
          src: '#modal-error',
          type: 'inline'
        })
        console.debug('Failed to get data: ', e)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  const onCellClick = useCallback(({ price, min, max, id, color, clarity }) => {
    setActiveRowCol({ min, max, color, clarity })
    setPrice(price)
    setPermissibleValues({ min, max })
    setActiveCell(id)
    toggleCalculator()
  }, [])

  const onCalculatorHideClick = (e) => {
    e.preventDefault()
    toggleCalculator(false)
  }

  const toggleCalculator = (isShow = true) => {
    setCalculatorIsShow(isShow)
  }

  switch (true) {
    case isLoading:
      return <Placeholder />
    default:
      return (
        <CalculatorContext.Provider
          value={{ onCellClick, tabs, activeCell, calculatorIsShow, onCalculatorHideClick, setActiveTab }}>
          <div className='price'>
            <Tabs />
            <Table tables={allTables} claritySort={claritySort} price={price} permissibleValues={permissibleValues} tabName={getActiveTab(tabs).name} activeRowCol={activeRowCol} />
          </div>
        </CalculatorContext.Provider>
      )
  }
}

export default App
